import { ColorModes } from '../../../Pricers/enums';

import { TransactionReviewStatus } from '../../enums/TransactionReviewStatus';
import { TransactionStatus } from '../../enums/TransactionStatus';
import { TransactionTypes } from '../../enums/TransactionTypes';

export const transactionTypeMapping = (transactionType: TransactionTypes) => {
  return transactionTypeNames[transactionType];
};

export const transactionTypeNames: Record<TransactionTypes, string> = {
  [TransactionTypes.live]: 'Live',
  [TransactionTypes.liveHypothetical]: 'Live - Hypothetical',
  [TransactionTypes.test]: 'Test',
  [TransactionTypes.valuation]: 'Valuation',
  [TransactionTypes.markedForDeletion]: 'Marked for Deletion',
  [TransactionTypes.internal]: 'Internal',
  [TransactionTypes.ifrsComponent]: 'IFRS Component',
};

export const transactionTypeColors: Record<TransactionTypes, ColorModes> = {
  [TransactionTypes.live]: ColorModes.success,
  [TransactionTypes.liveHypothetical]: ColorModes.violet,
  [TransactionTypes.test]: ColorModes.gray,
  [TransactionTypes.valuation]: ColorModes.gray,
  [TransactionTypes.markedForDeletion]: ColorModes.error,
  [TransactionTypes.internal]: ColorModes.blue,
  [TransactionTypes.ifrsComponent]: ColorModes.pinkGraph,
};

export const transactionTypeLabels: Record<
  TransactionTypes,
  string | undefined
> = {
  [TransactionTypes.live]: 'Live',
  [TransactionTypes.liveHypothetical]: 'Hypo',
  [TransactionTypes.test]: 'Test',
  [TransactionTypes.valuation]: 'Draft',
  [TransactionTypes.markedForDeletion]: 'Pending Delete',
  [TransactionTypes.internal]: 'Draft',
  [TransactionTypes.ifrsComponent]: 'Component',
};

// Maps the string `transaction_type` returned by the "my trades" endpoint to the
// numeric TransactionTypes enum so My Trades can reuse the Live tab pill colors/labels.
// Handles both the human-readable names and the enum-key serializations.
const transactionTypeStringMapping: Record<string, TransactionTypes> = {
  live: TransactionTypes.live,
  actual: TransactionTypes.live,
  'live - hypothetical': TransactionTypes.liveHypothetical,
  hypothetical: TransactionTypes.liveHypothetical,
  hypo: TransactionTypes.liveHypothetical,
  test: TransactionTypes.test,
  valuation: TransactionTypes.valuation,
  draft: TransactionTypes.valuation,
  'marked for deletion': TransactionTypes.markedForDeletion,
  deleted: TransactionTypes.markedForDeletion,
  internal: TransactionTypes.internal,
  'ifrs component': TransactionTypes.ifrsComponent,
  component: TransactionTypes.ifrsComponent,
};

export const resolveTransactionType = (
  transactionType: string | null | undefined,
): TransactionTypes | undefined => {
  if (!transactionType) return undefined;
  return transactionTypeStringMapping[transactionType.trim().toLowerCase()];
};

export const tradeStatusColors: Record<string, ColorModes> = {
  pending: ColorModes.warning,
  closed_out_not_matured: ColorModes.warning,
  deleted: ColorModes.error,
  deleted_pending: ColorModes.gray,
};

export const tradeStatusLabels: Record<string, string> = {
  pending: 'Pending',
  closed_out_not_matured: 'Closed',
  deleted: 'Deleted',
};

export const reviewStatusNames: Record<TransactionReviewStatus, string> = {
  [TransactionReviewStatus.pending]: 'Pending',
  [TransactionReviewStatus.approved]: 'Approved',
  [TransactionReviewStatus.amend]: 'Amend',
  [TransactionReviewStatus.rejected]: 'Rejected',
  [TransactionReviewStatus.problematic]: 'Problematic',
  [TransactionReviewStatus.reviewed]: 'Reviewed',
  [TransactionReviewStatus.pendingApproval]: 'Pending Approval',
};

export const reviewStatusMapping = (reviewStatus: TransactionReviewStatus) => {
  return reviewStatusNames[reviewStatus];
};

export const reviewStatusColors: Record<TransactionReviewStatus, ColorModes> = {
  [TransactionReviewStatus.pending]: ColorModes.warning,
  [TransactionReviewStatus.approved]: ColorModes.success,
  [TransactionReviewStatus.amend]: ColorModes.warning,
  [TransactionReviewStatus.rejected]: ColorModes.error,
  [TransactionReviewStatus.problematic]: ColorModes.warning,
  [TransactionReviewStatus.reviewed]: ColorModes.success,
  [TransactionReviewStatus.pendingApproval]: ColorModes.orange,
};

export const transactionStatusNames: Record<TransactionStatus, string> = {
  [TransactionStatus.closed]: 'Closed',
  [TransactionStatus.pmc]: 'PMC',
  [TransactionStatus.entity]: 'Entity',
  [TransactionStatus.open]: 'Open',
};

export const transactionStatusMapping = (
  transactionStatus: TransactionStatus,
) => {
  return transactionStatusNames[transactionStatus];
};

export const transactionStatusColors: Record<TransactionStatus, ColorModes> = {
  [TransactionStatus.closed]: ColorModes.gray,
  [TransactionStatus.pmc]: ColorModes.blue,
  [TransactionStatus.entity]: ColorModes.violet,
  [TransactionStatus.open]: ColorModes.success,
};
